<div class="main">
  <!-- 工程分类明细 -->
  <div *ngIf="vendorInfoData">
    <div class="classify">
      <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'TaskAssignment.EngineeringCategoryDetails' | translate }}</h4>
      <nz-list nzBordered>
        <nz-list-item *ngFor="let key of civlOrElectroInfo">
          <div class="classify-item">
            <span>{{ key.text }} -- </span>
            <span class="span-projectType" *ngIf="vendorInfoData['projectItemInfo'] !== undefined">{{ vendorInfoData['projectItemInfo'][key.value]['projectItemInfo'] }}</span>
          </div>
        </nz-list-item>
      </nz-list>
    </div>
    <!-- 派单厂务工程师 -->
    <div class="send-order">
      <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'TaskAssignment.DispatchFactoryEngineer' | translate }}</h4>
      <nz-list nzBordered>
        <nz-list-item>
          <div class="classify-item">
            <span style="margin-right: 10px;">{{ 'TaskAssignment.EngineerNameEmplid' | translate }}</span>
            <span class="span-value" style="font-size: 15px;"
              *ngIf="vendorInfoData['assignInfo'] !== undefined">
              {{ vendorInfoData['assignInfo']['assignName'] }}&nbsp;&nbsp;{{ vendorInfoData['assignInfo']['assignEmplid'] }}
            </span>
          </div>
          <!-- 单据是预约厂商时显示联系方式和输入框(预约厂商:appAppointStatus=true) -->
          <ng-container *ngIf="appointEditStatus && appAppointStatus">
            <div class="classify-phone">
              <span nz-typography class="content-phone">{{ 'TaskAssignment.EngineerPhone' | translate }}</span>
              <input nz-input [placeholder]="'TaskAssignment.EngineerPhoneNote' | translate" [(ngModel)]="assignPhone"
                (ngModelChange)="nzInputChanged($event)" />
            </div>
          </ng-container>
          <!-- 单据是预约厂商时显示联系方式电话,但是厂务签核--任务指派完成的单据处不显示,因为厂务联系电话是在预约厂商处填写的 -->
          <ng-container *ngIf=" appAppointStatus">
            <div class="classify-phone" *ngIf="!!getAssignPhone">
              <span nz-typography class="content-phone">{{ 'TaskAssignment.EngineerPhone' | translate }}</span>
              <span class="span-value" style="margin-left: 15px;">{{ getAssignPhone }}</span>
            </div>
          </ng-container>
        </nz-list-item>
      </nz-list>
    </div>
    <!-- 选择厂商 -->
    <div class="facturer">
      <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'TaskAssignment.SelectVendor' | translate }}</h4>
      <div class="facturer-body">
        <div>
          <div *ngFor="let type of civlOrElectroInfo">
            <em nz-icon nzType="plus-circle" nzTheme="outline"
              (click)="activeTable[type.value] = !activeTable[type.value]">
            </em>
            <span>{{ type.text }}{{ 'TaskAssignment.Vendor' | translate }}</span>
            <ng-container *ngIf="activeTable[type.value]">
              <nz-table class="facturerTable" #dataTable nzSize="small" [nzShowPagination]="false"
                [nzData]="vendorInfoData['vendorInfoo']">
                <thead>
                  <tr>
                    <th scope="col" *ngFor="let title of tableTitle">{{ title.text | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of vendorInfoData['vendorInfoo']">
                    <ng-container *ngIf="item['vendor'] === type.text">
                      <td>{{ item.vendorCode }}</td>
                      <td>{{ item.facturer }}</td>
                      <td>{{ item.professional }}</td>
                      <td>{{ item.contact }}</td>
                      <td>{{ item.tel }}</td>
                      <td nzBreakWord>{{ item.email }}</td>
                      <td>{{ item.issuedBid }}/{{ item.issuedBidTotal }}/{{ item.issuedBidPer }}</td>
                      <td>{{ item.issuedBidOverTime }}/{{ item.issuedBidOverTimeTotal }}/{{ item.issuedBidOverTimePer }}
                      </td>
                      <td>{{ item.notCooperateBids }}/{{ item.notCooperateBidsTotal }}/{{ item.notCooperateBidsPer }}
                      </td>
                      <td>{{ item.waitBidNumbers }}</td>
                    </ng-container>
                  </tr>
                </tbody>
              </nz-table>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>